import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "./anim";
import { FOUNDER_IMG } from "@/data";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "-10%"]);

  return (
    <section id="about" className="relative bg-ink-soft py-24 md:py-36 border-t border-line-d" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-12 gap-8 md:gap-12">
        <div className="col-span-12 lg:col-span-5">
          <div ref={ref} className="relative overflow-hidden aspect-[4/5] max-w-md bg-ink-soft">
            <motion.img style={{ y }} src={FOUNDER_IMG} alt="Tal Kedar" className="h-full w-full object-cover object-top img-treatment" />
            <div className="absolute inset-0 ring-1 ring-inset ring-line-d" />
          </div>
        </div>

        <div className="col-span-12 lg:col-span-7 lg:pl-8 flex flex-col justify-center">
          <Reveal>
            <Overline>Who we are</Overline>
            <h2 className="mt-6 font-display font-light text-3xl md:text-4xl lg:text-5xl text-sand leading-[1.15]">
              My name is Tal Kedar, and I started Beyond the Mask because I've watched a room change the moment someone drops the act — authenticity is what drives belonging and performance.
            </h2>
            <p className="mt-5 font-mono text-[11px] md:text-xs tracking-[0.2em] uppercase text-terra">
              Counsellor &amp; trained mental health professional · Master of Counselling · PACFA Certified
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 font-display text-2xl md:text-3xl text-sand leading-snug max-w-xl">
              Beyond the Mask builds trust, psychological safety and genuine connection through facilitated, experiential workshops.
            </p>
            <div className="mt-8 space-y-5 text-muted-d text-base md:text-lg leading-relaxed max-w-xl">
              <p>
                As a qualified counsellor and trained mental health professional, I facilitate the conversations most
                organisations avoid. My work sits at the intersection of psychological safety, honest leadership and human
                connection — the quiet forces behind every high-performing team.
              </p>
              <p>
                I don't do trust falls or motivational posters. I create carefully held spaces where teams can be
                genuinely seen, say the unsaid, and rebuild the connection that spreadsheets can't measure.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
